var $ccbe6066c10b1e53$exports = {};
$ccbe6066c10b1e53$exports = {
    "close": `St\xe4ng`,
    "notifications": `Aviseringar`
};


export {$ccbe6066c10b1e53$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
